/**
 * @generated SignedSource<<6e8b915e87357f4ba8a40e99e5f6568e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppointmentsSelectionMethod = "CLINICIAN" | "TIME" | "%future added value";
export type AppointmentsStatus = "CHECKED_IN" | "CONFIRMED" | "CONSULTED" | "LATE_CANCELLATION_EMERGENCY_MEDICAL_FIRE_ETC_" | "LATE_CANCELLATION_NO_SHOW_NO_CHARGE_CIGNA_MOM" | "LATE_CANCELLATION_NO_SHOW_NO_CHARGE_MEDICAID" | "LATE_CANCELLATION_NO_SHOW_NO_CHARGE_RESCHEDULED" | "LATE_CANCELLATION_NO_SHOW_PLEASE_CHARGE" | "NO_SHOW_CHARGE" | "NO_SHOW_NO_CHARGE" | "UNCONFIRMED" | "_2_HR_LATE_CANCEL_CHARGE" | "_2_HR_LATE_CANCEL_NO_CHARGE" | "%future added value";
export type EmployeeType = "EMPLOYEE" | "GENERIC" | "PRN" | "%future added value";
export type LeadsSource = "BREAST_PUMP_ORDER" | "FRIEND" | "HEALTH" | "HEALTH_PLAN" | "OTHER" | "REFERRAL_PARTNER" | "SEARCH" | "SOCIAL" | "%future added value";
export type LeadsStatus = "ACTIVE" | "CONVERTED" | "INACTIVE" | "NEW" | "%future added value";
export type PaymentProviders = "STRIPE" | "%future added value";
export type PolicyType = "CLINICIAN" | "GENERAL" | "PATIENT" | "%future added value";
export type ReferralPartnerType = "CLINICAL" | "DME" | "EMPLOYER" | "%future added value";
export type UserGender = "FEMALE" | "MALE" | "OTHER" | "%future added value";
export type UserInsuranceCategory = "AUTO" | "OTHER" | "PRIMARY" | "SECONDARY" | "TERTIARY" | "WORKERCOMP" | "%future added value";
export type UserInsurancePolicyHolderRelationship = "CHILD" | "OTHER" | "SELF" | "SPOUSE" | "UNKNOWN" | "%future added value";
export type UserInsuranceType = "CHAMPVA" | "FECA_BLK_LUNG" | "GROUP_HEALTH_PLAN" | "MEDICAID" | "MEDICARE" | "OTHER" | "TRICARE_CHAMPUS" | "%future added value";
export type UserPhonesType = "FAX" | "HOME" | "MOBILE" | "WORK" | "%future added value";
export type UsersOrderBy = "BIRTHDATE_AT_ASC" | "BIRTHDATE_AT_DESC" | "CLINICIAN_BY_USER_ID__CHARM_ID_ASC" | "CLINICIAN_BY_USER_ID__CHARM_ID_DESC" | "CLINICIAN_BY_USER_ID__CREATED_AT_ASC" | "CLINICIAN_BY_USER_ID__CREATED_AT_DESC" | "CLINICIAN_BY_USER_ID__EMPLOYEE_TYPE_ASC" | "CLINICIAN_BY_USER_ID__EMPLOYEE_TYPE_DESC" | "CLINICIAN_BY_USER_ID__ID_ASC" | "CLINICIAN_BY_USER_ID__ID_DESC" | "CLINICIAN_BY_USER_ID__INTRODUCTION_ASC" | "CLINICIAN_BY_USER_ID__INTRODUCTION_DESC" | "CLINICIAN_BY_USER_ID__SLUG_ASC" | "CLINICIAN_BY_USER_ID__SLUG_DESC" | "CLINICIAN_BY_USER_ID__SLUG_PUBLIC_ASC" | "CLINICIAN_BY_USER_ID__SLUG_PUBLIC_DESC" | "CLINICIAN_BY_USER_ID__UPDATED_AT_ASC" | "CLINICIAN_BY_USER_ID__UPDATED_AT_DESC" | "CLINICIAN_BY_USER_ID__USER_ID_ASC" | "CLINICIAN_BY_USER_ID__USER_ID_DESC" | "CREATED_AT_ASC" | "CREATED_AT_DESC" | "EMAIL_ASC" | "EMAIL_DESC" | "FIRST_NAME_ASC" | "FIRST_NAME_DESC" | "GENDER_ASC" | "GENDER_DESC" | "ID_ASC" | "ID_DESC" | "IS_ADMIN_ASC" | "IS_ADMIN_DESC" | "LAST_NAME_ASC" | "LAST_NAME_DESC" | "LEAD_BY_USER_ID__CONVERTED_AT_ASC" | "LEAD_BY_USER_ID__CONVERTED_AT_DESC" | "LEAD_BY_USER_ID__CREATED_AT_ASC" | "LEAD_BY_USER_ID__CREATED_AT_DESC" | "LEAD_BY_USER_ID__ID_ASC" | "LEAD_BY_USER_ID__ID_DESC" | "LEAD_BY_USER_ID__OPT_IN_AT_ASC" | "LEAD_BY_USER_ID__OPT_IN_AT_DESC" | "LEAD_BY_USER_ID__OPT_IN_METHOD_ASC" | "LEAD_BY_USER_ID__OPT_IN_METHOD_DESC" | "LEAD_BY_USER_ID__REFERRAL_PARTNER_ID_ASC" | "LEAD_BY_USER_ID__REFERRAL_PARTNER_ID_DESC" | "LEAD_BY_USER_ID__REFERRAL_PARTNER_SOURCE_ID_ASC" | "LEAD_BY_USER_ID__REFERRAL_PARTNER_SOURCE_ID_DESC" | "LEAD_BY_USER_ID__SLUG_ASC" | "LEAD_BY_USER_ID__SLUG_DESC" | "LEAD_BY_USER_ID__SOURCE_ASC" | "LEAD_BY_USER_ID__SOURCE_DESC" | "LEAD_BY_USER_ID__STATUS_ASC" | "LEAD_BY_USER_ID__STATUS_DESC" | "LEAD_BY_USER_ID__UPDATED_AT_ASC" | "LEAD_BY_USER_ID__UPDATED_AT_DESC" | "LEAD_BY_USER_ID__USER_ID_ASC" | "LEAD_BY_USER_ID__USER_ID_DESC" | "LEAD_BY_USER_ID__ZOHO_ID_ASC" | "LEAD_BY_USER_ID__ZOHO_ID_DESC" | "MIDDLE_NAME_ASC" | "MIDDLE_NAME_DESC" | "NATURAL" | "PATIENT_BY_USER_ID__CHARM_ID_ASC" | "PATIENT_BY_USER_ID__CHARM_ID_DESC" | "PATIENT_BY_USER_ID__CHARM_RECORD_ID_ASC" | "PATIENT_BY_USER_ID__CHARM_RECORD_ID_DESC" | "PATIENT_BY_USER_ID__CREATED_AT_ASC" | "PATIENT_BY_USER_ID__CREATED_AT_DESC" | "PATIENT_BY_USER_ID__ID_ASC" | "PATIENT_BY_USER_ID__ID_DESC" | "PATIENT_BY_USER_ID__SLUG_ASC" | "PATIENT_BY_USER_ID__SLUG_DESC" | "PATIENT_BY_USER_ID__UPDATED_AT_ASC" | "PATIENT_BY_USER_ID__UPDATED_AT_DESC" | "PATIENT_BY_USER_ID__USER_ID_ASC" | "PATIENT_BY_USER_ID__USER_ID_DESC" | "PATIENT_BY_USER_ID__ZOHO_ID_ASC" | "PATIENT_BY_USER_ID__ZOHO_ID_DESC" | "PRIMARY_KEY_ASC" | "PRIMARY_KEY_DESC" | "SLUG_ASC" | "SLUG_DESC" | "UPDATED_AT_ASC" | "UPDATED_AT_DESC" | "UPLOADS_BY_UPLOADER_ID__COUNT_ASC" | "UPLOADS_BY_UPLOADER_ID__COUNT_DESC" | "USER_ADDRESSES_BY_USER_ID__COUNT_ASC" | "USER_ADDRESSES_BY_USER_ID__COUNT_DESC" | "USER_CHILDREN_BY_USER_ID__COUNT_ASC" | "USER_CHILDREN_BY_USER_ID__COUNT_DESC" | "USER_INSURANCES_BY_USER_ID__COUNT_ASC" | "USER_INSURANCES_BY_USER_ID__COUNT_DESC" | "USER_LANGUAGES_BY_USER_ID__COUNT_ASC" | "USER_LANGUAGES_BY_USER_ID__COUNT_DESC" | "USER_PAYMENT_METHODS_BY_USER_ID__COUNT_ASC" | "USER_PAYMENT_METHODS_BY_USER_ID__COUNT_DESC" | "USER_PAYMENT_PROVIDERS_BY_USER_ID__COUNT_ASC" | "USER_PAYMENT_PROVIDERS_BY_USER_ID__COUNT_DESC" | "USER_PHONES_BY_USER_ID__COUNT_ASC" | "USER_PHONES_BY_USER_ID__COUNT_DESC" | "USER_POLICIES_BY_USER_ID__COUNT_ASC" | "USER_POLICIES_BY_USER_ID__COUNT_DESC" | "USER_UPLOADS_BY_USER_ID__COUNT_ASC" | "USER_UPLOADS_BY_USER_ID__COUNT_DESC" | "VERIFIED_AT_ASC" | "VERIFIED_AT_DESC" | "%future added value";
export type UserFilter = {
  and?: ReadonlyArray<UserFilter> | null;
  birthdateAt?: DateFilter | null;
  clinician?: ClinicianFilter | null;
  clinicianExists?: boolean | null;
  createdAt?: DatetimeFilter | null;
  email?: StringFilter | null;
  firstName?: StringFilter | null;
  gender?: UserGenderFilter | null;
  hasPassword?: BooleanFilter | null;
  isAdmin?: BooleanFilter | null;
  lastName?: StringFilter | null;
  lead?: LeadFilter | null;
  leadExists?: boolean | null;
  middleName?: StringFilter | null;
  not?: UserFilter | null;
  or?: ReadonlyArray<UserFilter> | null;
  patient?: PatientFilter | null;
  patientExists?: boolean | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
  uploadsByUploaderId?: UserToManyUploadFilter | null;
  uploadsByUploaderIdExist?: boolean | null;
  userAddresses?: UserToManyUserAddressFilter | null;
  userAddressesExist?: boolean | null;
  userChildren?: UserToManyUserChildFilter | null;
  userChildrenExist?: boolean | null;
  userInsurances?: UserToManyUserInsuranceFilter | null;
  userInsurancesExist?: boolean | null;
  userLanguages?: UserToManyUserLanguageFilter | null;
  userLanguagesExist?: boolean | null;
  userPaymentMethods?: UserToManyUserPaymentMethodFilter | null;
  userPaymentMethodsExist?: boolean | null;
  userPaymentProviders?: UserToManyUserPaymentProviderFilter | null;
  userPaymentProvidersExist?: boolean | null;
  userPhones?: UserToManyUserPhoneFilter | null;
  userPhonesExist?: boolean | null;
  userPolicies?: UserToManyUserPolicyFilter | null;
  userPoliciesExist?: boolean | null;
  userUploads?: UserToManyUserUploadFilter | null;
  userUploadsExist?: boolean | null;
  verifiedAt?: DatetimeFilter | null;
};
export type DateFilter = {
  distinctFrom?: any | null;
  equalTo?: any | null;
  greaterThan?: any | null;
  greaterThanOrEqualTo?: any | null;
  in?: ReadonlyArray<any> | null;
  isNull?: boolean | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  notDistinctFrom?: any | null;
  notEqualTo?: any | null;
  notIn?: ReadonlyArray<any> | null;
};
export type ClinicianFilter = {
  and?: ReadonlyArray<ClinicianFilter> | null;
  appointments?: ClinicianToManyAppointmentFilter | null;
  appointmentsExist?: boolean | null;
  charmId?: StringFilter | null;
  clinicianAvailabilities?: ClinicianToManyClinicianAvailabilityFilter | null;
  clinicianAvailabilitiesExist?: boolean | null;
  createdAt?: DatetimeFilter | null;
  employeeType?: EmployeeTypeFilter | null;
  introduction?: StringFilter | null;
  not?: ClinicianFilter | null;
  or?: ReadonlyArray<ClinicianFilter> | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  slugPublic?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type ClinicianToManyAppointmentFilter = {
  every?: AppointmentFilter | null;
  none?: AppointmentFilter | null;
  some?: AppointmentFilter | null;
};
export type AppointmentFilter = {
  and?: ReadonlyArray<AppointmentFilter> | null;
  charmId?: StringFilter | null;
  clinician?: ClinicianFilter | null;
  clinicianId?: UUIDFilter | null;
  createdAt?: DatetimeFilter | null;
  endsAt?: DatetimeFilter | null;
  not?: AppointmentFilter | null;
  notes?: StringFilter | null;
  or?: ReadonlyArray<AppointmentFilter> | null;
  patient?: PatientFilter | null;
  patientId?: UUIDFilter | null;
  rowId?: UUIDFilter | null;
  selectionMethod?: AppointmentsSelectionMethodFilter | null;
  service?: ServiceFilter | null;
  serviceId?: UUIDFilter | null;
  startsAt?: DatetimeFilter | null;
  status?: AppointmentsStatusFilter | null;
  updatedAt?: DatetimeFilter | null;
  userChild?: UserChildFilter | null;
  userChildExists?: boolean | null;
  userChildId?: UUIDFilter | null;
};
export type StringFilter = {
  distinctFrom?: string | null;
  distinctFromInsensitive?: string | null;
  endsWith?: string | null;
  endsWithInsensitive?: string | null;
  equalTo?: string | null;
  equalToInsensitive?: string | null;
  greaterThan?: string | null;
  greaterThanInsensitive?: string | null;
  greaterThanOrEqualTo?: string | null;
  greaterThanOrEqualToInsensitive?: string | null;
  in?: ReadonlyArray<string> | null;
  inInsensitive?: ReadonlyArray<string> | null;
  includes?: string | null;
  includesInsensitive?: string | null;
  isNull?: boolean | null;
  lessThan?: string | null;
  lessThanInsensitive?: string | null;
  lessThanOrEqualTo?: string | null;
  lessThanOrEqualToInsensitive?: string | null;
  like?: string | null;
  likeInsensitive?: string | null;
  notDistinctFrom?: string | null;
  notDistinctFromInsensitive?: string | null;
  notEndsWith?: string | null;
  notEndsWithInsensitive?: string | null;
  notEqualTo?: string | null;
  notEqualToInsensitive?: string | null;
  notIn?: ReadonlyArray<string> | null;
  notInInsensitive?: ReadonlyArray<string> | null;
  notIncludes?: string | null;
  notIncludesInsensitive?: string | null;
  notLike?: string | null;
  notLikeInsensitive?: string | null;
  notStartsWith?: string | null;
  notStartsWithInsensitive?: string | null;
  startsWith?: string | null;
  startsWithInsensitive?: string | null;
};
export type UUIDFilter = {
  distinctFrom?: any | null;
  equalTo?: any | null;
  greaterThan?: any | null;
  greaterThanOrEqualTo?: any | null;
  in?: ReadonlyArray<any> | null;
  isNull?: boolean | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  notDistinctFrom?: any | null;
  notEqualTo?: any | null;
  notIn?: ReadonlyArray<any> | null;
};
export type DatetimeFilter = {
  distinctFrom?: any | null;
  equalTo?: any | null;
  greaterThan?: any | null;
  greaterThanOrEqualTo?: any | null;
  in?: ReadonlyArray<any> | null;
  isNull?: boolean | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  notDistinctFrom?: any | null;
  notEqualTo?: any | null;
  notIn?: ReadonlyArray<any> | null;
};
export type PatientFilter = {
  and?: ReadonlyArray<PatientFilter> | null;
  appointments?: PatientToManyAppointmentFilter | null;
  appointmentsExist?: boolean | null;
  charmId?: StringFilter | null;
  charmRecordId?: StringFilter | null;
  createdAt?: DatetimeFilter | null;
  not?: PatientFilter | null;
  or?: ReadonlyArray<PatientFilter> | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
  zohoId?: StringFilter | null;
};
export type PatientToManyAppointmentFilter = {
  every?: AppointmentFilter | null;
  none?: AppointmentFilter | null;
  some?: AppointmentFilter | null;
};
export type AppointmentsSelectionMethodFilter = {
  distinctFrom?: AppointmentsSelectionMethod | null;
  equalTo?: AppointmentsSelectionMethod | null;
  greaterThan?: AppointmentsSelectionMethod | null;
  greaterThanOrEqualTo?: AppointmentsSelectionMethod | null;
  in?: ReadonlyArray<AppointmentsSelectionMethod> | null;
  isNull?: boolean | null;
  lessThan?: AppointmentsSelectionMethod | null;
  lessThanOrEqualTo?: AppointmentsSelectionMethod | null;
  notDistinctFrom?: AppointmentsSelectionMethod | null;
  notEqualTo?: AppointmentsSelectionMethod | null;
  notIn?: ReadonlyArray<AppointmentsSelectionMethod> | null;
};
export type ServiceFilter = {
  and?: ReadonlyArray<ServiceFilter> | null;
  appointments?: ServiceToManyAppointmentFilter | null;
  appointmentsExist?: boolean | null;
  charmServiceId?: StringFilter | null;
  createdAt?: DatetimeFilter | null;
  duration?: IntervalFilter | null;
  isActive?: BooleanFilter | null;
  name?: StringFilter | null;
  not?: ServiceFilter | null;
  or?: ReadonlyArray<ServiceFilter> | null;
  price?: BigFloatFilter | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
};
export type ServiceToManyAppointmentFilter = {
  every?: AppointmentFilter | null;
  none?: AppointmentFilter | null;
  some?: AppointmentFilter | null;
};
export type IntervalFilter = {
  distinctFrom?: IntervalInput | null;
  equalTo?: IntervalInput | null;
  greaterThan?: IntervalInput | null;
  greaterThanOrEqualTo?: IntervalInput | null;
  in?: ReadonlyArray<IntervalInput> | null;
  isNull?: boolean | null;
  lessThan?: IntervalInput | null;
  lessThanOrEqualTo?: IntervalInput | null;
  notDistinctFrom?: IntervalInput | null;
  notEqualTo?: IntervalInput | null;
  notIn?: ReadonlyArray<IntervalInput> | null;
};
export type IntervalInput = {
  days?: number | null;
  hours?: number | null;
  minutes?: number | null;
  months?: number | null;
  seconds?: number | null;
  years?: number | null;
};
export type BooleanFilter = {
  distinctFrom?: boolean | null;
  equalTo?: boolean | null;
  greaterThan?: boolean | null;
  greaterThanOrEqualTo?: boolean | null;
  in?: ReadonlyArray<boolean> | null;
  isNull?: boolean | null;
  lessThan?: boolean | null;
  lessThanOrEqualTo?: boolean | null;
  notDistinctFrom?: boolean | null;
  notEqualTo?: boolean | null;
  notIn?: ReadonlyArray<boolean> | null;
};
export type BigFloatFilter = {
  distinctFrom?: any | null;
  equalTo?: any | null;
  greaterThan?: any | null;
  greaterThanOrEqualTo?: any | null;
  in?: ReadonlyArray<any> | null;
  isNull?: boolean | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  notDistinctFrom?: any | null;
  notEqualTo?: any | null;
  notIn?: ReadonlyArray<any> | null;
};
export type AppointmentsStatusFilter = {
  distinctFrom?: AppointmentsStatus | null;
  equalTo?: AppointmentsStatus | null;
  greaterThan?: AppointmentsStatus | null;
  greaterThanOrEqualTo?: AppointmentsStatus | null;
  in?: ReadonlyArray<AppointmentsStatus> | null;
  isNull?: boolean | null;
  lessThan?: AppointmentsStatus | null;
  lessThanOrEqualTo?: AppointmentsStatus | null;
  notDistinctFrom?: AppointmentsStatus | null;
  notEqualTo?: AppointmentsStatus | null;
  notIn?: ReadonlyArray<AppointmentsStatus> | null;
};
export type UserChildFilter = {
  and?: ReadonlyArray<UserChildFilter> | null;
  appointments?: UserChildToManyAppointmentFilter | null;
  appointmentsExist?: boolean | null;
  birthdateAt?: DateFilter | null;
  createdAt?: DatetimeFilter | null;
  dueAt?: DateFilter | null;
  name?: StringFilter | null;
  not?: UserChildFilter | null;
  or?: ReadonlyArray<UserChildFilter> | null;
  rowId?: UUIDFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type UserChildToManyAppointmentFilter = {
  every?: AppointmentFilter | null;
  none?: AppointmentFilter | null;
  some?: AppointmentFilter | null;
};
export type ClinicianToManyClinicianAvailabilityFilter = {
  every?: ClinicianAvailabilityFilter | null;
  none?: ClinicianAvailabilityFilter | null;
  some?: ClinicianAvailabilityFilter | null;
};
export type ClinicianAvailabilityFilter = {
  and?: ReadonlyArray<ClinicianAvailabilityFilter> | null;
  clinician?: ClinicianFilter | null;
  clinicianId?: UUIDFilter | null;
  createdAt?: DatetimeFilter | null;
  endsAt?: DatetimeFilter | null;
  googleCalendarEventId?: StringFilter | null;
  isExclusive?: BooleanFilter | null;
  not?: ClinicianAvailabilityFilter | null;
  or?: ReadonlyArray<ClinicianAvailabilityFilter> | null;
  recurDuration?: IntervalFilter | null;
  recurEvery?: IntervalFilter | null;
  rowId?: UUIDFilter | null;
  startsAt?: DatetimeFilter | null;
  updatedAt?: DatetimeFilter | null;
};
export type EmployeeTypeFilter = {
  distinctFrom?: EmployeeType | null;
  equalTo?: EmployeeType | null;
  greaterThan?: EmployeeType | null;
  greaterThanOrEqualTo?: EmployeeType | null;
  in?: ReadonlyArray<EmployeeType> | null;
  isNull?: boolean | null;
  lessThan?: EmployeeType | null;
  lessThanOrEqualTo?: EmployeeType | null;
  notDistinctFrom?: EmployeeType | null;
  notEqualTo?: EmployeeType | null;
  notIn?: ReadonlyArray<EmployeeType> | null;
};
export type UserGenderFilter = {
  distinctFrom?: UserGender | null;
  equalTo?: UserGender | null;
  greaterThan?: UserGender | null;
  greaterThanOrEqualTo?: UserGender | null;
  in?: ReadonlyArray<UserGender> | null;
  isNull?: boolean | null;
  lessThan?: UserGender | null;
  lessThanOrEqualTo?: UserGender | null;
  notDistinctFrom?: UserGender | null;
  notEqualTo?: UserGender | null;
  notIn?: ReadonlyArray<UserGender> | null;
};
export type LeadFilter = {
  and?: ReadonlyArray<LeadFilter> | null;
  convertedAt?: DatetimeFilter | null;
  createdAt?: DatetimeFilter | null;
  not?: LeadFilter | null;
  optInAt?: DatetimeFilter | null;
  optInMethod?: StringFilter | null;
  or?: ReadonlyArray<LeadFilter> | null;
  referralPartner?: ReferralPartnerFilter | null;
  referralPartnerExists?: boolean | null;
  referralPartnerId?: UUIDFilter | null;
  referralPartnerSource?: ReferralPartnerSourceFilter | null;
  referralPartnerSourceExists?: boolean | null;
  referralPartnerSourceId?: UUIDFilter | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  source?: LeadsSourceFilter | null;
  status?: LeadsStatusFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
  zohoId?: StringFilter | null;
};
export type ReferralPartnerFilter = {
  and?: ReadonlyArray<ReferralPartnerFilter> | null;
  config?: JSONFilter | null;
  createdAt?: DatetimeFilter | null;
  isActive?: BooleanFilter | null;
  leads?: ReferralPartnerToManyLeadFilter | null;
  leadsExist?: boolean | null;
  name?: StringFilter | null;
  not?: ReferralPartnerFilter | null;
  or?: ReadonlyArray<ReferralPartnerFilter> | null;
  referralPartnerSources?: ReferralPartnerToManyReferralPartnerSourceFilter | null;
  referralPartnerSourcesExist?: boolean | null;
  referralPartnerUploads?: ReferralPartnerToManyReferralPartnerUploadFilter | null;
  referralPartnerUploadsExist?: boolean | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  slugPublic?: StringFilter | null;
  type?: ReferralPartnerTypeFilter | null;
  updatedAt?: DatetimeFilter | null;
};
export type JSONFilter = {
  containedBy?: any | null;
  contains?: any | null;
  containsAllKeys?: ReadonlyArray<string> | null;
  containsAnyKeys?: ReadonlyArray<string> | null;
  containsKey?: string | null;
  distinctFrom?: any | null;
  equalTo?: any | null;
  greaterThan?: any | null;
  greaterThanOrEqualTo?: any | null;
  in?: ReadonlyArray<any> | null;
  isNull?: boolean | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  notDistinctFrom?: any | null;
  notEqualTo?: any | null;
  notIn?: ReadonlyArray<any> | null;
};
export type ReferralPartnerToManyLeadFilter = {
  every?: LeadFilter | null;
  none?: LeadFilter | null;
  some?: LeadFilter | null;
};
export type ReferralPartnerToManyReferralPartnerSourceFilter = {
  every?: ReferralPartnerSourceFilter | null;
  none?: ReferralPartnerSourceFilter | null;
  some?: ReferralPartnerSourceFilter | null;
};
export type ReferralPartnerSourceFilter = {
  and?: ReadonlyArray<ReferralPartnerSourceFilter> | null;
  description?: StringFilter | null;
  isActive?: BooleanFilter | null;
  leads?: ReferralPartnerSourceToManyLeadFilter | null;
  leadsExist?: boolean | null;
  name?: StringFilter | null;
  not?: ReferralPartnerSourceFilter | null;
  or?: ReadonlyArray<ReferralPartnerSourceFilter> | null;
  referralPartner?: ReferralPartnerFilter | null;
  referralPartnerId?: UUIDFilter | null;
  rowId?: UUIDFilter | null;
};
export type ReferralPartnerSourceToManyLeadFilter = {
  every?: LeadFilter | null;
  none?: LeadFilter | null;
  some?: LeadFilter | null;
};
export type ReferralPartnerToManyReferralPartnerUploadFilter = {
  every?: ReferralPartnerUploadFilter | null;
  none?: ReferralPartnerUploadFilter | null;
  some?: ReferralPartnerUploadFilter | null;
};
export type ReferralPartnerUploadFilter = {
  and?: ReadonlyArray<ReferralPartnerUploadFilter> | null;
  createdAt?: DatetimeFilter | null;
  name?: StringFilter | null;
  not?: ReferralPartnerUploadFilter | null;
  or?: ReadonlyArray<ReferralPartnerUploadFilter> | null;
  referralPartner?: ReferralPartnerFilter | null;
  referralPartnerId?: UUIDFilter | null;
  rowId?: UUIDFilter | null;
  updatedAt?: DatetimeFilter | null;
  upload?: UploadFilter | null;
  uploadId?: UUIDFilter | null;
};
export type UploadFilter = {
  and?: ReadonlyArray<UploadFilter> | null;
  bucket?: StringFilter | null;
  createdAt?: DatetimeFilter | null;
  filename?: StringFilter | null;
  filesize?: IntFilter | null;
  filetype?: StringFilter | null;
  key?: StringFilter | null;
  not?: UploadFilter | null;
  or?: ReadonlyArray<UploadFilter> | null;
  referralPartnerUploads?: UploadToManyReferralPartnerUploadFilter | null;
  referralPartnerUploadsExist?: boolean | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
  uploader?: UserFilter | null;
  uploaderExists?: boolean | null;
  uploaderId?: UUIDFilter | null;
  userInsuranceUploads?: UploadToManyUserInsuranceUploadFilter | null;
  userInsuranceUploadsExist?: boolean | null;
  userUploads?: UploadToManyUserUploadFilter | null;
  userUploadsExist?: boolean | null;
};
export type IntFilter = {
  distinctFrom?: number | null;
  equalTo?: number | null;
  greaterThan?: number | null;
  greaterThanOrEqualTo?: number | null;
  in?: ReadonlyArray<number> | null;
  isNull?: boolean | null;
  lessThan?: number | null;
  lessThanOrEqualTo?: number | null;
  notDistinctFrom?: number | null;
  notEqualTo?: number | null;
  notIn?: ReadonlyArray<number> | null;
};
export type UploadToManyReferralPartnerUploadFilter = {
  every?: ReferralPartnerUploadFilter | null;
  none?: ReferralPartnerUploadFilter | null;
  some?: ReferralPartnerUploadFilter | null;
};
export type UploadToManyUserInsuranceUploadFilter = {
  every?: UserInsuranceUploadFilter | null;
  none?: UserInsuranceUploadFilter | null;
  some?: UserInsuranceUploadFilter | null;
};
export type UserInsuranceUploadFilter = {
  and?: ReadonlyArray<UserInsuranceUploadFilter> | null;
  createdAt?: DatetimeFilter | null;
  name?: StringFilter | null;
  not?: UserInsuranceUploadFilter | null;
  or?: ReadonlyArray<UserInsuranceUploadFilter> | null;
  rowId?: UUIDFilter | null;
  updatedAt?: DatetimeFilter | null;
  upload?: UploadFilter | null;
  uploadId?: UUIDFilter | null;
  userInsurance?: UserInsuranceFilter | null;
  userInsuranceId?: UUIDFilter | null;
};
export type UserInsuranceFilter = {
  and?: ReadonlyArray<UserInsuranceFilter> | null;
  category?: UserInsuranceCategoryFilter | null;
  charmId?: StringFilter | null;
  comments?: StringFilter | null;
  createdAt?: DatetimeFilter | null;
  groupId?: StringFilter | null;
  insuranceProvider?: InsuranceProviderFilter | null;
  insuranceProviderId?: UUIDFilter | null;
  memberId?: StringFilter | null;
  not?: UserInsuranceFilter | null;
  or?: ReadonlyArray<UserInsuranceFilter> | null;
  policyHolderAddressCity?: StringFilter | null;
  policyHolderAddressCountry?: StringFilter | null;
  policyHolderAddressPostalCode?: StringFilter | null;
  policyHolderAddressStateOrProvince?: StringFilter | null;
  policyHolderAddressStreet1?: StringFilter | null;
  policyHolderAddressStreet2?: StringFilter | null;
  policyHolderBirthdateAt?: DateFilter | null;
  policyHolderFirstName?: StringFilter | null;
  policyHolderGender?: StringFilter | null;
  policyHolderHomePhone?: StringFilter | null;
  policyHolderLastName?: StringFilter | null;
  policyHolderMobilePhone?: StringFilter | null;
  policyHolderRelationship?: UserInsurancePolicyHolderRelationshipFilter | null;
  policyHolderSsn?: StringFilter | null;
  rowId?: UUIDFilter | null;
  type?: UserInsuranceTypeFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
  userInsuranceUploads?: UserInsuranceToManyUserInsuranceUploadFilter | null;
  userInsuranceUploadsExist?: boolean | null;
  validAt?: DateFilter | null;
};
export type UserInsuranceCategoryFilter = {
  distinctFrom?: UserInsuranceCategory | null;
  equalTo?: UserInsuranceCategory | null;
  greaterThan?: UserInsuranceCategory | null;
  greaterThanOrEqualTo?: UserInsuranceCategory | null;
  in?: ReadonlyArray<UserInsuranceCategory> | null;
  isNull?: boolean | null;
  lessThan?: UserInsuranceCategory | null;
  lessThanOrEqualTo?: UserInsuranceCategory | null;
  notDistinctFrom?: UserInsuranceCategory | null;
  notEqualTo?: UserInsuranceCategory | null;
  notIn?: ReadonlyArray<UserInsuranceCategory> | null;
};
export type InsuranceProviderFilter = {
  and?: ReadonlyArray<InsuranceProviderFilter> | null;
  charmId?: StringFilter | null;
  createdAt?: DatetimeFilter | null;
  name?: StringFilter | null;
  not?: InsuranceProviderFilter | null;
  or?: ReadonlyArray<InsuranceProviderFilter> | null;
  payerId?: StringFilter | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
  userInsurances?: InsuranceProviderToManyUserInsuranceFilter | null;
  userInsurancesExist?: boolean | null;
};
export type InsuranceProviderToManyUserInsuranceFilter = {
  every?: UserInsuranceFilter | null;
  none?: UserInsuranceFilter | null;
  some?: UserInsuranceFilter | null;
};
export type UserInsurancePolicyHolderRelationshipFilter = {
  distinctFrom?: UserInsurancePolicyHolderRelationship | null;
  equalTo?: UserInsurancePolicyHolderRelationship | null;
  greaterThan?: UserInsurancePolicyHolderRelationship | null;
  greaterThanOrEqualTo?: UserInsurancePolicyHolderRelationship | null;
  in?: ReadonlyArray<UserInsurancePolicyHolderRelationship> | null;
  isNull?: boolean | null;
  lessThan?: UserInsurancePolicyHolderRelationship | null;
  lessThanOrEqualTo?: UserInsurancePolicyHolderRelationship | null;
  notDistinctFrom?: UserInsurancePolicyHolderRelationship | null;
  notEqualTo?: UserInsurancePolicyHolderRelationship | null;
  notIn?: ReadonlyArray<UserInsurancePolicyHolderRelationship> | null;
};
export type UserInsuranceTypeFilter = {
  distinctFrom?: UserInsuranceType | null;
  equalTo?: UserInsuranceType | null;
  greaterThan?: UserInsuranceType | null;
  greaterThanOrEqualTo?: UserInsuranceType | null;
  in?: ReadonlyArray<UserInsuranceType> | null;
  isNull?: boolean | null;
  lessThan?: UserInsuranceType | null;
  lessThanOrEqualTo?: UserInsuranceType | null;
  notDistinctFrom?: UserInsuranceType | null;
  notEqualTo?: UserInsuranceType | null;
  notIn?: ReadonlyArray<UserInsuranceType> | null;
};
export type UserInsuranceToManyUserInsuranceUploadFilter = {
  every?: UserInsuranceUploadFilter | null;
  none?: UserInsuranceUploadFilter | null;
  some?: UserInsuranceUploadFilter | null;
};
export type UploadToManyUserUploadFilter = {
  every?: UserUploadFilter | null;
  none?: UserUploadFilter | null;
  some?: UserUploadFilter | null;
};
export type UserUploadFilter = {
  and?: ReadonlyArray<UserUploadFilter> | null;
  createdAt?: DatetimeFilter | null;
  name?: StringFilter | null;
  not?: UserUploadFilter | null;
  or?: ReadonlyArray<UserUploadFilter> | null;
  rowId?: UUIDFilter | null;
  updatedAt?: DatetimeFilter | null;
  upload?: UploadFilter | null;
  uploadId?: UUIDFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type ReferralPartnerTypeFilter = {
  distinctFrom?: ReferralPartnerType | null;
  equalTo?: ReferralPartnerType | null;
  greaterThan?: ReferralPartnerType | null;
  greaterThanOrEqualTo?: ReferralPartnerType | null;
  in?: ReadonlyArray<ReferralPartnerType> | null;
  isNull?: boolean | null;
  lessThan?: ReferralPartnerType | null;
  lessThanOrEqualTo?: ReferralPartnerType | null;
  notDistinctFrom?: ReferralPartnerType | null;
  notEqualTo?: ReferralPartnerType | null;
  notIn?: ReadonlyArray<ReferralPartnerType> | null;
};
export type LeadsSourceFilter = {
  distinctFrom?: LeadsSource | null;
  equalTo?: LeadsSource | null;
  greaterThan?: LeadsSource | null;
  greaterThanOrEqualTo?: LeadsSource | null;
  in?: ReadonlyArray<LeadsSource> | null;
  isNull?: boolean | null;
  lessThan?: LeadsSource | null;
  lessThanOrEqualTo?: LeadsSource | null;
  notDistinctFrom?: LeadsSource | null;
  notEqualTo?: LeadsSource | null;
  notIn?: ReadonlyArray<LeadsSource> | null;
};
export type LeadsStatusFilter = {
  distinctFrom?: LeadsStatus | null;
  equalTo?: LeadsStatus | null;
  greaterThan?: LeadsStatus | null;
  greaterThanOrEqualTo?: LeadsStatus | null;
  in?: ReadonlyArray<LeadsStatus> | null;
  isNull?: boolean | null;
  lessThan?: LeadsStatus | null;
  lessThanOrEqualTo?: LeadsStatus | null;
  notDistinctFrom?: LeadsStatus | null;
  notEqualTo?: LeadsStatus | null;
  notIn?: ReadonlyArray<LeadsStatus> | null;
};
export type UserToManyUploadFilter = {
  every?: UploadFilter | null;
  none?: UploadFilter | null;
  some?: UploadFilter | null;
};
export type UserToManyUserAddressFilter = {
  every?: UserAddressFilter | null;
  none?: UserAddressFilter | null;
  some?: UserAddressFilter | null;
};
export type UserAddressFilter = {
  address?: AddressFilter | null;
  addressId?: UUIDFilter | null;
  and?: ReadonlyArray<UserAddressFilter> | null;
  createdAt?: DatetimeFilter | null;
  isPrimary?: BooleanFilter | null;
  not?: UserAddressFilter | null;
  or?: ReadonlyArray<UserAddressFilter> | null;
  rowId?: UUIDFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type AddressFilter = {
  and?: ReadonlyArray<AddressFilter> | null;
  city?: StringFilter | null;
  country?: StringFilter | null;
  createdAt?: DatetimeFilter | null;
  not?: AddressFilter | null;
  or?: ReadonlyArray<AddressFilter> | null;
  postalCode?: StringFilter | null;
  rowId?: UUIDFilter | null;
  stateOrProvince?: StringFilter | null;
  street1?: StringFilter | null;
  street2?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
  userAddresses?: AddressToManyUserAddressFilter | null;
  userAddressesExist?: boolean | null;
};
export type AddressToManyUserAddressFilter = {
  every?: UserAddressFilter | null;
  none?: UserAddressFilter | null;
  some?: UserAddressFilter | null;
};
export type UserToManyUserChildFilter = {
  every?: UserChildFilter | null;
  none?: UserChildFilter | null;
  some?: UserChildFilter | null;
};
export type UserToManyUserInsuranceFilter = {
  every?: UserInsuranceFilter | null;
  none?: UserInsuranceFilter | null;
  some?: UserInsuranceFilter | null;
};
export type UserToManyUserLanguageFilter = {
  every?: UserLanguageFilter | null;
  none?: UserLanguageFilter | null;
  some?: UserLanguageFilter | null;
};
export type UserLanguageFilter = {
  and?: ReadonlyArray<UserLanguageFilter> | null;
  createdAt?: DatetimeFilter | null;
  isPrimary?: BooleanFilter | null;
  language?: StringFilter | null;
  not?: UserLanguageFilter | null;
  or?: ReadonlyArray<UserLanguageFilter> | null;
  rowId?: UUIDFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type UserToManyUserPaymentMethodFilter = {
  every?: UserPaymentMethodFilter | null;
  none?: UserPaymentMethodFilter | null;
  some?: UserPaymentMethodFilter | null;
};
export type UserPaymentMethodFilter = {
  and?: ReadonlyArray<UserPaymentMethodFilter> | null;
  createdAt?: DatetimeFilter | null;
  isActive?: BooleanFilter | null;
  isPrimary?: BooleanFilter | null;
  methodId?: StringFilter | null;
  not?: UserPaymentMethodFilter | null;
  or?: ReadonlyArray<UserPaymentMethodFilter> | null;
  provider?: PaymentProvidersFilter | null;
  providerId?: StringFilter | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type PaymentProvidersFilter = {
  distinctFrom?: PaymentProviders | null;
  equalTo?: PaymentProviders | null;
  greaterThan?: PaymentProviders | null;
  greaterThanOrEqualTo?: PaymentProviders | null;
  in?: ReadonlyArray<PaymentProviders> | null;
  isNull?: boolean | null;
  lessThan?: PaymentProviders | null;
  lessThanOrEqualTo?: PaymentProviders | null;
  notDistinctFrom?: PaymentProviders | null;
  notEqualTo?: PaymentProviders | null;
  notIn?: ReadonlyArray<PaymentProviders> | null;
};
export type UserToManyUserPaymentProviderFilter = {
  every?: UserPaymentProviderFilter | null;
  none?: UserPaymentProviderFilter | null;
  some?: UserPaymentProviderFilter | null;
};
export type UserPaymentProviderFilter = {
  and?: ReadonlyArray<UserPaymentProviderFilter> | null;
  createdAt?: DatetimeFilter | null;
  isActive?: BooleanFilter | null;
  isPrimary?: BooleanFilter | null;
  not?: UserPaymentProviderFilter | null;
  or?: ReadonlyArray<UserPaymentProviderFilter> | null;
  provider?: PaymentProvidersFilter | null;
  providerId?: StringFilter | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type UserToManyUserPhoneFilter = {
  every?: UserPhoneFilter | null;
  none?: UserPhoneFilter | null;
  some?: UserPhoneFilter | null;
};
export type UserPhoneFilter = {
  and?: ReadonlyArray<UserPhoneFilter> | null;
  createdAt?: DatetimeFilter | null;
  isPrimary?: BooleanFilter | null;
  not?: UserPhoneFilter | null;
  or?: ReadonlyArray<UserPhoneFilter> | null;
  phone?: StringFilter | null;
  rowId?: UUIDFilter | null;
  type?: UserPhonesTypeFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type UserPhonesTypeFilter = {
  distinctFrom?: UserPhonesType | null;
  equalTo?: UserPhonesType | null;
  greaterThan?: UserPhonesType | null;
  greaterThanOrEqualTo?: UserPhonesType | null;
  in?: ReadonlyArray<UserPhonesType> | null;
  isNull?: boolean | null;
  lessThan?: UserPhonesType | null;
  lessThanOrEqualTo?: UserPhonesType | null;
  notDistinctFrom?: UserPhonesType | null;
  notEqualTo?: UserPhonesType | null;
  notIn?: ReadonlyArray<UserPhonesType> | null;
};
export type UserToManyUserPolicyFilter = {
  every?: UserPolicyFilter | null;
  none?: UserPolicyFilter | null;
  some?: UserPolicyFilter | null;
};
export type UserPolicyFilter = {
  acceptedAt?: DatetimeFilter | null;
  and?: ReadonlyArray<UserPolicyFilter> | null;
  createdAt?: DatetimeFilter | null;
  not?: UserPolicyFilter | null;
  or?: ReadonlyArray<UserPolicyFilter> | null;
  policy?: PolicyFilter | null;
  policyId?: UUIDFilter | null;
  rowId?: UUIDFilter | null;
  updatedAt?: DatetimeFilter | null;
  user?: UserFilter | null;
  userId?: UUIDFilter | null;
};
export type PolicyFilter = {
  and?: ReadonlyArray<PolicyFilter> | null;
  bodyEn?: StringFilter | null;
  bodyEs?: StringFilter | null;
  createdAt?: DatetimeFilter | null;
  description?: StringFilter | null;
  name?: StringFilter | null;
  not?: PolicyFilter | null;
  or?: ReadonlyArray<PolicyFilter> | null;
  rowId?: UUIDFilter | null;
  slug?: StringFilter | null;
  type?: PolicyTypeFilter | null;
  updatedAt?: DatetimeFilter | null;
  userPolicies?: PolicyToManyUserPolicyFilter | null;
  userPoliciesExist?: boolean | null;
  validAt?: DatetimeFilter | null;
};
export type PolicyTypeFilter = {
  distinctFrom?: PolicyType | null;
  equalTo?: PolicyType | null;
  greaterThan?: PolicyType | null;
  greaterThanOrEqualTo?: PolicyType | null;
  in?: ReadonlyArray<PolicyType> | null;
  isNull?: boolean | null;
  lessThan?: PolicyType | null;
  lessThanOrEqualTo?: PolicyType | null;
  notDistinctFrom?: PolicyType | null;
  notEqualTo?: PolicyType | null;
  notIn?: ReadonlyArray<PolicyType> | null;
};
export type PolicyToManyUserPolicyFilter = {
  every?: UserPolicyFilter | null;
  none?: UserPolicyFilter | null;
  some?: UserPolicyFilter | null;
};
export type UserToManyUserUploadFilter = {
  every?: UserUploadFilter | null;
  none?: UserUploadFilter | null;
  some?: UserUploadFilter | null;
};
export type UsersTablePaginationQuery$variables = {
  after?: any | null;
  filter?: UserFilter | null;
  first?: number | null;
  orderBy?: ReadonlyArray<UsersOrderBy> | null;
};
export type UsersTablePaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UsersTable_query">;
};
export type UsersTablePaginationQuery = {
  response: UsersTablePaginationQuery$data;
  variables: UsersTablePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": [
      "LAST_NAME_ASC"
    ],
    "kind": "LocalArgument",
    "name": "orderBy"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersTablePaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "UsersTable_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UsersConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UsersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Clinician",
                    "kind": "LinkedField",
                    "name": "clinician",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAdmin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Patient",
                    "kind": "LinkedField",
                    "name": "patient",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "isPrimary": {
                            "equalTo": true
                          }
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      }
                    ],
                    "concreteType": "UserPhonesConnection",
                    "kind": "LinkedField",
                    "name": "userPhones",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserPhone",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phone",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "userPhones(filter:{\"isPrimary\":{\"equalTo\":true}},first:1)"
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "verifiedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "name": {
                            "equalTo": "avatar"
                          }
                        }
                      }
                    ],
                    "concreteType": "UserUploadsConnection",
                    "kind": "LinkedField",
                    "name": "userUploads",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserUpload",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Upload",
                            "kind": "LinkedField",
                            "name": "upload",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "userUploads(filter:{\"name\":{\"equalTo\":\"avatar\"}})"
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter",
          "orderBy"
        ],
        "handle": "connection",
        "key": "UsersTable_query_users",
        "kind": "LinkedHandle",
        "name": "users"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de317e6c5d343de7ee9a671f7f246bd8",
    "id": null,
    "metadata": {},
    "name": "UsersTablePaginationQuery",
    "operationKind": "query",
    "text": "query UsersTablePaginationQuery(\n  $after: Cursor\n  $filter: UserFilter\n  $first: Int\n  $orderBy: [UsersOrderBy!] = [LAST_NAME_ASC]\n) {\n  ...UsersTable_query_5SL3L\n}\n\nfragment CreateUserModal_query on Query {\n  ...UserForm_query\n}\n\nfragment UserAvatar_user on User {\n  firstName\n  lastName\n  userUploads(filter: {name: {equalTo: \"avatar\"}}) {\n    nodes {\n      upload {\n        url\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment UserForm_query on Query {\n  currentUser {\n    rowId\n    id\n  }\n}\n\nfragment UsersTable_query_5SL3L on Query {\n  users(after: $after, filter: $filter, first: $first, orderBy: $orderBy) {\n    edges {\n      node {\n        clinician {\n          slug\n          id\n        }\n        email\n        isAdmin\n        firstName\n        lastName\n        patient {\n          slug\n          id\n        }\n        userPhones(filter: {isPrimary: {equalTo: true}}, first: 1) {\n          nodes {\n            phone\n            id\n          }\n        }\n        slug\n        verifiedAt\n        ...UserAvatar_user\n        id\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...CreateUserModal_query\n}\n"
  }
};
})();

(node as any).hash = "630a902162746233bfee58c4628f2e64";

export default node;
